<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('saleContract.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('saleContract.pageTitle'),
            href: '/admin/sale-contract',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal">
            <div class="ts-border ts-p-3 ts-rounded ts-border-gray-200">
              <div class="row">
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label class="col-md-3 col-form-label required">{{
                      $t('quotation.date')
                    }}</label>
                    <div class="col-md-6">
                      <a-date-picker
                        v-model="model.contract_date"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                        class="ts-w-full"
                      ></a-date-picker>
                      <div class="validate" v-if="errors.has('quotation_date')">
                        {{ errors.first('quotation_date') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label required">{{
                      $t('quotation.customer')
                    }}</label>
                    <div class="col-md-6">
                      <a-select
                        v-model="model.customer_id"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        showSearch
                        :options="customerList"
                        class="ts-w-full"
                      ></a-select>
                      <div class="validate" v-if="errors.has('customer_id')">
                        {{ errors.first('customer_id') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('saleContract.referenceNo')
                    }}</label>
                    <div class="col-md-6">
                      <ReferenceNumber v-model="model" />
                      <div class="validate" v-if="errors.has('reference_no')">
                        {{ errors.first('reference_no') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('saleContract.projectName')
                    }}</label>
                    <div class="col-md-6">
                      <input
                        v-model.trim="model.project_name"
                        type="text"
                        class="form-control"
                      />
                      <div class="validate" v-if="errors.has('project_name')">
                        {{ errors.first('project_name') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-12">
                <Detail v-model="model" :validate="errors" class="ts-border ts-shadow-inner ts-rounded ts-p-3" />
              </div>
            </div>
            <div class="row ts-mt-4">
              <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2">
                <ts-button
                  @click.prevent="$router.push({ name: 'sale-contract' })"
                  >{{ $t('cancel') }}</ts-button
                >
                <ts-button
                  :waiting="waiting_preview"
                  @click.prevent="saveAddNew"
                  color="primary"
                  outline
                  >{{ $t('savePrint') }}</ts-button
                >
                <ts-button
                  :waiting="waiting"
                  @click.prevent="onSave"
                  color="primary"
                  >{{ $t('save') }}</ts-button
                >
              </div>
            </div>
          </form>
        </ts-loading-banner>
        <a-modal
          :title="$t('pdf')"
          width="50%"
          v-model="show_pdf"
          :footer="null"
        >
          <ts-preview-pdf v-model="waiting_preview" :src="src" />
        </a-modal>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import Detail from './components/item-detail'
import ReferenceNumber from './components/reference-number.vue'
export default {
  name: 'quotationCreate',
  components: {
    Detail,
    ReferenceNumber
  },
  data() {
    return {
      waiting: false,
      waiting_preview: false,
      loading: false,
      show_pdf: false,
      errors: new Errors(),
      src: null,
      model: {
        contract_date: moment().format('DD-MM-YYYY'),
        project_name: null,
        customer_id: null,
        grand_total: null,
        vat_rate: null,
        vat_amount: null,
        total_exclude_vat: null,
        reference_no: null,
        item_list: [],
      },
    }
  },
  async created() {
    this.model.vat_rate = parseFloat(
      this.$store.state.authUser.sys_setting.vat_rate
    )
    this.loading = true
    await this.fetchQuotation()
    await this.fetchResource().finally(() => (this.loading = false))
  },
  computed: {
    ...mapState('wholesale/saleContract', ['customers']),
    customerList() {
      return this.customers.map((el) => ({
        value: el.customer_id,
        label: el.customer_name,
      }))
    },
  },
  methods: {
    ...mapActions('wholesale/saleContract', ['fetchQuotation', 'fetchResource', 'store']),
    saveAddNew() {
      this.waiting_preview = true
      this.show_pdf = true
      this.errors = new Errors()
      this.store(this.model)
        .then((response) => {
          this.src = response.url
          this.clearInput()
          this.fetchQuot()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting_preview = false
        })
    },
    onSave() {
      this.waiting = true
      this.errors = new Errors()
      this.store(this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'sale-contract' })
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    fetchQuot(){
      this.loading = true
      this.fetchQuotation()
        .finally(() => {
          this.loading = false
        })
    },
    clearInput() {
      this.model.contract_date = moment().format('DD-MM-YYYY')
      this.model.project_name = null
      this.model.reference_no = null
      this.model.customer_id = null
      this.model.grand_total = null
      this.model.vat_amount = null
      this.model.total_exclude_vat = null
      this.model.item_list = []
      this.errors = new Errors()
    },
  },
  beforeRouteLeave(to, from, next) {
    next(vm => {
      vm.$store.commit('wholesale/saleContract/CLEAR_SETUP')
    })
  },
}
</script>